
import * as React from 'react';
import styled from 'styled-components';
import * as lo from 'lodash/fp';

import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Event } from '@process-advisor/process-miner/api/events';
import { DataGrid } from '@process-advisor/process-miner/time/lifecycle/dataGrid';
import { eventDetailGridColumns } from '@process-advisor/process-miner/time/lifecycle/eventDetailGridColumns';

type Row = {};
let columns = []
const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 5px;
`;

export const EventDetailGrid: React.FC = () => {
    const [data, setData] = React.useState<Row[]>([]);

    React.useEffect(() => {
        const listener = () => {
            apiProvider.setEventDetailExtract({type: 'tia'})
            setData(apiProvider.processDetailEventSummary());
        }
        listener();

        apiProvider.on(Event.openEventDetailModal, listener);

        return () => {
            apiProvider.off(Event.openEventDetailModal, listener);
        };
    }, []);

    const rows = data.map((row, id) => ({ id, ...row }));
    if (lo.isEmpty(columns)) {
        columns = eventDetailGridColumns(rows);
    }
    
    return (
        <Wrapper>
            <DataGrid
                rows={rows}
                columns={columns}
                height="300px" />
        </Wrapper>
    );
};
